import SearchBar from 'components/Autosuggest/Autosuggest';
import Currency from 'components/Currency/Currency';
import React, { useState } from 'react';
import {  searchItems } from 'services/api/inventoryItems';
import { showError, showSuccess } from 'utils';
import styles from './index.module.scss';
import { setInventoryItemAddress } from 'services';
import ItemAddress from 'pages/inventory-items/detail/ItemAddress';

const AddInventoryItemOnAddressModal = props => {
  const {
    toggleModal,
    onSuccess,
    addressObj = {},
  } = props;
  const [name, setName] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [item, setItem] = useState<Record<string, any>>({});
  const [startAddress, setStartAddress] = useState(addressObj);
  const [endAddress, setEndAddress] = useState(addressObj); 
  const [itemSelected, setItemSelected] = useState<boolean>(false);
  
  const addInventoryItem = async (e: React.FormEvent<EventTarget>) => {
    e.preventDefault();
    setLoading(true);
    const data = { id: item.id,
      startInventoryAddress: startAddress,
      endInventoryAddress: endAddress,
    };
    
    try {
      await setInventoryItemAddress(data);
      showSuccess('Item added successfully');
      await onSuccess();
      toggleModal();
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  const handleSuggestionClick = (suggestion: Record<string, any>) => {
   
    setItem(suggestion);
    setItemSelected(true);
    
  };

  const ItemInfo = () => (
    <div className={styles['item-details']}>
      {item.image && (
        <div className={styles['item-image']}>
          <img src={item.image} />
        </div>
      )}
      <div>
        <div className={styles['item-name-section']}>
          <div className={styles['label']}>Item Name</div>
          <div className={styles['item-name']}>{item.displayName || 'N/A'}</div>
        </div>
        <div className={styles['category-section']}>
          <div className={styles['label']}>Category</div>
          <div className={styles['item-category']}>{item.category?.displayName || 'N/A'}</div>
        </div>
        <div className={styles['price-section']}>
          <div className={styles['label']}>Price</div>
          <div className={styles['item-price']}>{<Currency amount={item.price}/>}</div>
        </div>
      </div>
    </div>
  );

  return (
    <div className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            {/* <div className={styles['label']}>Inventory Item</div> */}
            <div className={styles['modal-title']}>Add An Inventory Item to the Address</div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          <div className={'mb-3'}>
            <div className={styles['label']}>Item Name</div>
            <div className={styles['autosuggest-container']}>
              <SearchBar
                value={name}
                setValue={value => setName(value)}
                clearOnSelect={false}
                searchAPI={(e)=>searchItems(e, '0')}
                searchAPIParamKey={'term'}
                onSuggestionClicked={handleSuggestionClick}
              />
            </div>
          </div>
          <div className={styles['item-address-container']}> 
            <ItemAddress
              addressType={'Start'}
              inventoryAddress={startAddress}
              editInfo={true}
              loading={loading}
              setAddress={(key, obj)=>{
                setStartAddress(obj);
              }}
              labelClass={styles['address-label']}
            />
            <ItemAddress
              addressType={'End'}
              inventoryAddress={endAddress}
              editInfo={true}
              loading={loading}
              setAddress={(key, obj)=>{
                setEndAddress(obj);
              }}
              labelClass={styles['address-label']}
            />
            {itemSelected && <ItemInfo />}
          </div>
          
        </div>
        <div className={styles['modal-footer']}>
          <button
            className={styles['cancel-button']}
            onClick={toggleModal}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            onClick={addInventoryItem}
            className={styles['submit-button']}
            disabled={loading}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddInventoryItemOnAddressModal;
